// @ts-check

/** @file Shared request marker for AwesomeTasks-owned frontend API calls. */

export const APP_FRONTEND_REQUEST_HEADER = "x-awesome-tasks-frontend"
export const APP_FRONTEND_REQUEST_VALUE = "app"
